"use client";

import { useEffect } from "react";

const CHUNK_RELOAD_KEY = "mirofish:chunk-reload-attempted";

const isChunkLoadFailure = (value: unknown) => {
  const message =
    value instanceof Error
      ? `${value.name} ${value.message}`
      : typeof value === "string"
        ? value
        : "";

  return /ChunkLoadError|Loading chunk \d+ failed|Failed to load chunk|_next\/static\/chunks/i.test(
    message
  );
};

export default function ChunkLoadRecovery() {
  useEffect(() => {
    const recover = (reason: unknown) => {
      if (!isChunkLoadFailure(reason)) {
        return;
      }

      const lastAttempt = Number(sessionStorage.getItem(CHUNK_RELOAD_KEY) || "0");
      if (Date.now() - lastAttempt < 60_000) {
        return;
      }

      sessionStorage.setItem(CHUNK_RELOAD_KEY, String(Date.now()));
      window.location.reload();
    };

    const handleError = (event: ErrorEvent) => {
      recover(event.error || event.message);
    };
    const handleRejection = (event: PromiseRejectionEvent) => {
      recover(event.reason);
    };

    window.addEventListener("error", handleError);
    window.addEventListener("unhandledrejection", handleRejection);
    return () => {
      window.removeEventListener("error", handleError);
      window.removeEventListener("unhandledrejection", handleRejection);
    };
  }, []);

  return null;
}
